import HeaderCMS from "@/components/navigation/HeaderCMS.tsx";
import { useAuth } from "@/context/auth/AuthContext";
import React from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRouteCMS = ({ children }: PrivateRouteProps) => {
  const { t } = useTranslation();
  const { checkInstanceAndToken, instanceData } = useAuth();

  const haveCMSId = instanceData?.CMS?.id;

  if (!checkInstanceAndToken()) {
    return <Navigate to="/login" />;
  } else {
    return (
      <>
        <HeaderCMS />
        {haveCMSId && children}
        {!haveCMSId && (
          <div className="flex flex-col items-center justify-center h-screen">
            <p className="text-2xl font-bold">{t("titleNoCMSIdCreated")}</p>
            <p className="text-sm">{t("descriptionNoCMSIdCreated")}</p>
          </div>
        )}
      </>
    );
  }
};
